import type { TabProps as ReactTabProps } from 'react-tabs'
import { Tab as ReactTab } from 'react-tabs'
import styled, { css } from 'styled-components'
import type { TabProps } from './types'

export const TabContainer = styled(ReactTab)<
  {
    $direction: NonNullable<TabProps['direction']>
    $marginSize: TabProps['size']
  } & ReactTabProps
>``

export const Tab = styled.button<{
  $isActive: boolean | undefined
  $direction: NonNullable<TabProps['direction']>
  $variant: NonNullable<TabProps['variant']>
  $size: TabProps['size']
  $weight: TabProps['weight']
  $scrollable: TabProps['scrollable']
}>`
  position: relative;

  cursor: pointer;

  &:hover,
  &:focus {
    color: var(--text-brand);
    outline: none;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    display: block;
    width: 100%;
    height: 2px;
    background: var(--text-primary);
    opacity: 0;
  }

  ${({ $size }) =>
    $size === 'medium' &&
    css`
      font-size: var(--font-size-400);
      line-height: var(--font-line-height-400);
    `}

  ${({ $size }) =>
    $size === 'large' &&
    css`
      font-size: var(--font-size-500);
      line-height: var(--font-line-height-600);
      font-weight: var(--font-weight-semibold);
    `}

  ${({ $weight }) =>
    $weight === 'bold' &&
    css`
      font-weight: var(--font-weight-semibold);
    `}

  ${({ $variant }) =>
    $variant === 'dimmed' &&
    css`
      color: var(--text-secondary);
    `};

  ${({ $scrollable }) =>
    $scrollable &&
    css`
      white-space: nowrap;
    `};

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: var(--text-primary) !important;

      &:after {
        opacity: 1;
      }
    `};
`
